import client from './index';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async getAnnouncementList(token: string) {
    try {
      const response = await client.get('/v2/announcements/home', {
        headers: {'player-token': token},
      });
      return response.data;
    } catch (error) {
      console.error('An error occurred while fetching the announcement list:', error);
      return null;
    }
  },
};
